module.exports = __webpack_public_path__ + "media/images/icons/chevron-down-4946c4b16441a79b1c37f39da6988561.svg";